import { usePreviewImage } from '@euler/app/components/media/ImageViewerContext';
import { Typography } from '@euler/app/components/typography';
import { OrderExtra } from '@euler/app/flows/order/types';
import { SiteIcon } from '@euler/app/flows/task/components/SiteIcon';
import { Center } from '@euler/components/Center';
import { Img } from '@euler/components/image/AdvancedImage';
import { HStack } from '@euler/components/layout/Stack';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { InventoryQuery } from '@euler/functions/useInventory';
import { SiteInspectionType } from '@euler/model/enum';
import { usePersistFn } from '@euler/utils/hooks';
import { memo } from 'react';
import { TouchableWithoutFeedback, View } from 'react-native';
import { OrderInfoCell as Cell } from './Cell';
import { OrderPreviewSection as Section } from './Section';

export const DashboardInfoSection = memo(
  ({
    dashboardImgUrl,
    detail,
    inventoryQuery,
  }: {
    dashboardImgUrl: string | undefined;
    detail: OrderExtra;
    inventoryQuery: InventoryQuery;
  }) => {
    const { rpx } = useResponsiveContext();
    const dashboardInspections = detail.preInspection?.filter(
      x => x.inspectionType === SiteInspectionType.Dashboard,
    );

    const previewImage = usePreviewImage();

    const onPreviewDashboardImage = usePersistFn(() => {
      if (!dashboardImgUrl) return;
      previewImage({
        imageUrls: [dashboardImgUrl],
      });
    });

    if (!dashboardImgUrl && !dashboardInspections?.length) {
      return null;
    }

    return (
      <Section title="仪表/油量信息">
        {dashboardImgUrl ? (
          <TouchableWithoutFeedback onPress={onPreviewDashboardImage}>
            <View
              css={`
                padding: ${rpx(10)}px ${rpx(15)}px;
              `}
            >
              <Img
                uri={dashboardImgUrl}
                css={`
                  aspect-ratio: ${5 / 4};
                  border-radius: ${rpx(10)}px;
                  overflow: hidden;
                `}
              />
            </View>
          </TouchableWithoutFeedback>
        ) : null}
        {dashboardInspections?.map((inspection, index, array) => {
          const site = inventoryQuery.getSiteById(inspection.siteId);
          if (!site) return null;
          const icon = site.iconUrl;
          return (
            <Cell
              key={inspection.siteCode}
              last={index === array.length - 1}
              titleView={
                <HStack justifyContent="flex-start">
                  <SiteIcon
                    url={icon}
                    type={
                      icon
                        ? icon.includes('.svg')
                          ? 'svg'
                          : 'image'
                        : undefined
                    }
                    size={rpx(20)}
                    color="#888"
                    css={`
                      margin-right: ${rpx(8)}px;
                    `}
                  />
                  <Typography.Label
                    medium
                    size={rpx(16)}
                    color="rgb(102, 102, 102)"
                  >
                    {site.name}
                  </Typography.Label>
                </HStack>
              }
            >
              <Center
                css={`
                  background-color: rgba(255, 122, 0, 0.2);
                  width: ${rpx(48)}px;
                  height: ${rpx(24)}px;
                  border-radius: ${rpx(3)}px;
                `}
              >
                <Typography.Label
                  regular
                  size={rpx(14)}
                  align="center"
                  lineHeight={rpx(24)}
                  color="rgb(255, 122, 0)"
                >
                  点亮
                </Typography.Label>
              </Center>
            </Cell>
          );
        })}
      </Section>
    );
  },
);
